const actionBlockListItems = document.querySelectorAll('.action-block-list-item');
const postListItems = document.querySelectorAll('.post-list-item');


const init = function() {

  if ( actionBlockListItems ) {
    setupClickableTiles( actionBlockListItems );
  }

  if ( postListItems ) {
    setupClickableTiles( postListItems );
  }

};


const setupClickableTiles = function( tiles ) {

  tiles.forEach( tile => {
    const linkElement = tile.querySelector('a');
    if ( linkElement ) {
      tile.style.cursor = 'pointer';
      const url = linkElement.getAttribute('href');
      tile.addEventListener( "click", () => {
        window.location = url;
      } );
    }
  } );

}


const api = {
	init: init
};

export default api;